import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './CouponCode.module.sass';

function CouponCode(props) {
  const [code, setCode] = useState('');

  const {
    orderNumber, guestToken, applyCouponCodeRequest, couponCodeErrorText, couponCodeSuccessText,
  } = props;

  const onChange = (event) => {
    setCode(event.target.value);
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (code.trim().length === 0) {
      return;
    }

    applyCouponCodeRequest({ orderNumber, code, guestToken });
  };

  return (
    <form onSubmit={onSubmit} className={styles['coupon-code']}>
      <div className={styles.title}>Have a Coupon Code?</div>
      <div className={styles.content}>
        <div className={styles.form}>
          <input type="text" value={code} onChange={onChange} />
          <button type="submit">Add</button>
        </div>
        <div className={styles.result}>
          {couponCodeSuccessText && (
            <div className={styles.success}>
              { couponCodeSuccessText }
            </div>
          )}
          {couponCodeErrorText && (
            <div className={styles.error}>
              { couponCodeErrorText }
            </div>
          )}
        </div>
      </div>
    </form>
  );
}

CouponCode.propTypes = {
  applyCouponCodeRequest: PropTypes.func.isRequired,
  couponCodeErrorText: PropTypes.string,
  couponCodeSuccessText: PropTypes.string,
  guestToken: PropTypes.string,
  orderNumber: PropTypes.string,
};

export default CouponCode;
